export default "__VITE_ASSET__Bfs$Gc$6__"